import { render } from "./vagentcensus.vue?vue&type=template&id=67a78b9f&scoped=true"
import script from "./vagentcensus.vue?vue&type=script&lang=js"
export * from "./vagentcensus.vue?vue&type=script&lang=js"

import "./vagentcensus.vue?vue&type=style&index=0&id=67a78b9f&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a78b9f"]])

export default __exports__